import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // 👈 import it
import { initAnalytics } from "./utils/analytics";

initAnalytics();

// Handle root route redirection based on environment
if (typeof window !== 'undefined' && process.env.REACT_APP_HOMEPAGE && process.env.REACT_APP_HOMEPAGE !== '/' && window.location.pathname === '/') {
  window.location.href = process.env.REACT_APP_HOMEPAGE;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.register(); // 👈 register the service worker

reportWebVitals();
